<template>
  <box-default>
    <waiting-list :loading-content="loading">
      <box-list-filter title="Relatório de CSAT">
        <datapicker-global col="3" variable-name="csat" have-range-days-max="" :range-days-init="rangeDays"
                           label="Filtrar por data" is-required="true"/>

        <input-text col="3" have-icon="true" icon type="text" placeholder="Digite o ID"
                    label="ID da empresa" @contentText="value => listFilters.companyId = value"/>

        <input-text col="3" have-icon="true" icon type="text" placeholder="Digite o nome"
                    label="Nome da empresa" @contentText="value => listFilters.companyName = value"/>

        <input-select col="3" :options="listFiltersOptions.stage" label="Etapa"
                      @selectedOption="value => listFilters.stage = value"/>

        <input-select col="3" :options="listFiltersOptions.noteExp" label="Nota experiencia"
                      @selectedOption="value => listFilters.noteExp = value"/>

        <input-select col="3" :options="listFiltersOptions.noteScore" label="Nota atendimento"
                      @selectedOption="value => listFilters.noteScore = value"/>

        <input-select col="3" :options="listFiltersOptions.responsible" label="Responsável"
                      @selectedOptionString="value => listFilters.responsible = value"
                      :name-only-string="true"/>
        <input-select col="3" :options="listFiltersOptions.statusAnswered" label="Status da resposta"
                      @selectedOptionNumber="value => listFilters.statusAnswered = value" value-is-number="true"/>
        <btn-custom @emit-click="getList()" col="6" label="Pesquisar" which-side="left"/>
      </box-list-filter>

      <waiting-list :loading-content="loadingList">

        <mini-card-details dinamic-body="true" text-align="center" title="CSAT Atendimento" col="3">
          <template>
            <div class="status">
              <span v-if="dataCode.attendingCsat === 5" class="status__emote" style="color: #2ACC6B">
                <img style="background: #2ACC6B" src="../../../../assets/img/emote/feliz-coracao.png" alt="img">
                Excelente
              </span>
              <span v-else-if="dataCode.attendingCsat === 4" class="status__emote" style="color: #2ACC6B">
                <img style="background: #2ACC6B" src="../../../../assets/img/emote/feliz.png" alt="img">
                Bom
              </span>
              <span v-else-if="dataCode.attendingCsat === 3" class="status__emote" style="color: #FF9900">
                <img style="background: #FF9900" src="../../../../assets/img/emote/neutro.png" alt="img">
                Médio
              </span>
              <span v-else-if="dataCode.attendingCsat === 2" class="status__emote" style="color: #FF445D">
                <img style="background: #FF445D" src="../../../../assets/img/emote/triste.png" alt="img">
                Ruim
              </span>
              <span v-else-if="dataCode.attendingCsat === 1" class="status__emote" style="color: #FF445D">
                <img style="background: #FF445D" src="../../../../assets/img/emote/bravo.png" alt="img">
                Muito ruim
              </span>
              <span v-else class="status__emote" style="color: #7F8897">
                <img style="background: #D5DFEB" src="../../../../assets/img/emote/neutro-empty.png" alt="img">
                -
              </span>
            </div>
          </template>
        </mini-card-details>

        <mini-card-details title="Meta CSAT" col="9" dinamic-body="true" text-align="center">
          <template>
            <div class="csat-goal">
              <div class="col-md-6">
                <h2>Nota de experiência:</h2>
                <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25"
                     aria-valuemin="0" aria-valuemax="100">
                  <div
                    v-if="dataCode.experienceActualByPeriod && dataCode.experienceActualByPeriod < dataCode.experienceGoal"
                    class="progress-bar bg-progress"
                    :style="'width:' + dataCode.experienceGoal + '%'">
                    {{ dataCode.experienceGoal }}%
                  </div>
                  <div
                    v-if="dataCode.experienceActualByPeriod && dataCode.experienceActualByPeriod > dataCode.experienceGoal"
                    class="progress-bar complete-goal"
                    :style="'width:' + dataCode.experienceGoal + '%'">
                    <ion-icon name="flag-outline"></ion-icon>
                  </div>
                  <div v-if="dataCode.experienceActualByPeriod" class="progress-bar"
                       :style="{width: dataCode.experienceActualByPeriod + '%', background: bgExperienceBar}">
                    {{ dataCode.experienceActualByPeriod }}%
                  </div>
                </div>
                <div class="tooltip-csat">
                  <p>Meta de experiência: <span>{{ dataCode.experienceGoal }}%</span></p>
                  <p>Realizado: <span>{{ dataCode.experienceActualByPeriod }}%</span></p>
                </div>
              </div>
              <div class="col-md-6">
                <h2>Taxa de resposta:</h2>
                <div class="progress" role="progressbar" aria-label="Example with label" aria-valuenow="25"
                     aria-valuemin="0" aria-valuemax="100">
                  <div v-if="dataCode.responseActualByPeriod && dataCode.responseActualByPeriod < dataCode.responseGoal"
                       class="progress-bar bg-progress"
                       :style="'width:' + dataCode.responseGoal + '%'">
                    {{ dataCode.responseGoal }}%
                  </div>
                  <div
                    v-if="dataCode.responseActualByPeriod && dataCode.responseActualByPeriod > dataCode.responseGoal"
                    class="progress-bar complete-goal"
                    :style="'width:' + dataCode.responseGoal + '%'">
                    <ion-icon name="flag-outline"></ion-icon>
                  </div>
                  <div v-if="dataCode.responseActualByPeriod" class="progress-bar"
                       :style="{width: dataCode.responseActualByPeriod + '%', background: bgResponseBar}">
                    {{ dataCode.responseActualByPeriod }}%
                  </div>
                </div>
                <div class="tooltip-csat">
                  <p>Meta: <span>{{ dataCode.responseGoal }}%</span><span
                    v-if="dataCode.responseActualByPeriod > dataCode.responseGoal">(Alcançada)</span></p>
                  <p>Respondido: <span>{{ dataCode.totalResponse }} de {{ dataCode.totalItems }}</span></p>
                  <p>Não respondido: <span>{{ dataCode.totalNotResponse }}</span></p>
                </div>
              </div>
            </div>
            <p class="status-csat-goal">Status:
              <span v-if="dataCode.experienceCsat === 1">Muito ruim</span>
              <span v-if="dataCode.experienceCsat === 2">Ruim</span>
              <span v-if="dataCode.experienceCsat === 3">Médio</span>
              <span v-if="dataCode.experienceCsat === 4">Bom</span>
              <span v-if="dataCode.experienceCsat === 5">Excelente</span>
            </p>
          </template>
        </mini-card-details>

        <box-listing @emit-excel="createExcel()" title="Lista de CSAT" :loading-excel="loadingExcel"
                     :empty-state="!listContent.body.length"
                     :columns-list-header="listContent.header" :total-items="dataCode.totalItems" have-excel="true">
          <template>
            <tr v-for="(list, index) in listContent.body" :key="index" class="csat">
              <td>
                <router-link :to="'/detalhes-da-empresa/' + list.companyId + '/' + list.contextCompany">
                  {{ list.companyName }}
                </router-link>
              </td>
              <td class="csat__status">
                <span v-if="list.experienceScore === 1" class="csat__note">
                  <img src="../../../../assets/img/emote/bravo.png" alt="img"/>
                  {{ list.experienceWeightByScore }}
                  <span>Muito ruim</span>
                </span>
                <span v-else-if="list.experienceScore === 2" class="csat__note">
                  <img src="../../../../assets/img/emote/triste.png" alt="img"/>
                  {{ list.experienceWeightByScore }}
                  <span>Ruim</span>
                </span>
                <span v-else-if="list.experienceScore === 3" class="csat__note">
                  <img src="../../../../assets/img/emote/neutro.png" alt="img"/>
                  {{ list.experienceWeightByScore }}
                  <span>Médio</span>
                </span>
                <span v-else-if="list.experienceScore === 4" class="csat__note">
                  <img src="../../../../assets/img/emote/feliz.png" alt="img"/>
                  {{ list.experienceWeightByScore }}
                  <span>Bom</span>
                </span>
                <span v-else-if="list.experienceScore === 5" class="csat__note">
                  <img src="../../../../assets/img/emote/feliz-coracao.png" alt="img"/>
                  {{ list.experienceWeightByScore }}
                  <span>Excelente</span>
                </span>
                <span v-else class="csat__note">
                  <img src="../../../../assets/img/emote/neutro-empty.png" alt="img"/>
                  -
                </span>
              </td>
              <td class="csat__status">
                <span v-if="list.attendingScore === 1" class="csat__note">
                  <img src="../../../../assets/img/emote/bravo.png" alt="img"/>
                  {{ list.attendingWeightByScore }}
                  <span>Muito ruim</span>
                </span>
                <span v-else-if="list.attendingScore === 2" class="csat__note">
                  <img src="../../../../assets/img/emote/triste.png" alt="img"/>
                  {{ list.attendingWeightByScore }}
                  <span>Ruim</span>
                </span>
                <span v-else-if="list.attendingScore === 3" class="csat__note">
                  <img src="../../../../assets/img/emote/neutro.png" alt="img"/>
                  {{ list.attendingWeightByScore }}
                  <span>Médio</span>
                </span>
                <span v-else-if="list.attendingScore === 4" class="csat__note">
                  <img src="../../../../assets/img/emote/feliz.png" alt="img"/>
                  {{ list.attendingWeightByScore }}
                  <span>Bom</span>
                </span>
                <span v-else-if="list.attendingScore === 5" class="csat__note">
                  <img src="../../../../assets/img/emote/feliz-coracao.png" alt="img"/>
                  {{ list.attendingWeightByScore }}
                  <span>Excelente</span>
                </span>
                <span v-else class="csat__note">
                  <img src="../../../../assets/img/emote/neutro-empty.png" alt="img"/>
                  -
                </span>
              </td>
              <td>{{ list.comment }}</td>
              <td>
                <span v-if="list.journey === 1">Trial</span>
                <span v-else-if="list.journey === 2">Onboarding</span>
                <span v-else-if="list.journey === 3">Middle</span>
                <span v-else-if="list.journey === 4">Ongoing</span>
                <span v-else> - </span>
              </td>
              <td>{{ list.userResponsible }}</td>
              <td>{{ list.responseDate | formatDate }}</td>
              <td class="csat__remove">
            <span @click="removeCSAT(list.id, list.contextCompany)">
              <ion-icon name="trash-outline"/>remover&nbsp;
            </span>
              </td>
            </tr>
          </template>
        </box-listing>
      </waiting-list>
    </waiting-list>
  </box-default>
</template>

<script>
import BoxDefault from "../../components/layouts/boxDefault.vue";
import BoxListFilter from "../../components/layouts/boxListFilter.vue";
import DatapickerGlobal from "../../components/inputs/datapickerGlobal.vue";
import InputText from "../../components/inputs/inputText.vue";
import InputSelect from "../../components/inputs/inputSelect.vue";
import BtnSearch from "../../components/buttons/btnSearch.vue";
import MiniCardDetails from "../../components/layouts/miniCardDetails.vue";
import BoxListing from "../../components/layouts/boxListing.vue";
import swal from "sweetalert";
import {REQUEST_SERVICE} from "../../../../requestConfig";
import {DELETE_CSAT, GET_LIST_CSAT, GET_SELECT_RESPONSIBLES, POST_REPORT_CSAT} from "../../../../urlConfig";
import {UTIL_SERVICE} from "../../../../utils";
import {ALERT_SERVICE} from "../../../../msgAlertService";
import WaitingList from "../../components/layouts/waitingList.vue";
import moment from "moment";
import BtnCustom from "../../components/buttons/btnCustom.vue";
import ModalDefault from "../../components/modals/modalDefault.vue";
import InputCheckbox from "../../components/inputs/inputCheckbox.vue";

export default {
  name: "reportCSAT",
  components: {
    InputCheckbox,
    ModalDefault,
    BtnCustom,
    WaitingList,
    BoxListing,
    MiniCardDetails,
    BtnSearch,
    InputSelect,
    DatapickerGlobal,
    BoxListFilter,
    BoxDefault,
    InputText
  },
  data() {
    return {
      loading: false,
      loadingList: false,
      dataCode: '',
      bgExperienceBar: '',
      bgResponseBar: '',
      listFiltersOptions: {
        noteExp: [
          {
            name: 'Selecione',
            id: ''
          },
          {
            name: 'Muito ruim',
            id: 1
          },
          {
            name: 'Ruim',
            id: 2
          },
          {
            name: 'Médio',
            id: 3
          },
          {
            name: 'Bom',
            id: 4
          },
          {
            name: 'Excelente',
            id: 5
          },
        ],
        noteScore: [
          {
            name: 'Selecione',
            id: ''
          },
          {
            name: 'Muito ruim',
            id: 1
          },
          {
            name: 'Ruim',
            id: 2
          },
          {
            name: 'Médio',
            id: 3
          },
          {
            name: 'Bom',
            id: 4
          },
          {
            name: 'Excelente',
            id: 5
          },
        ],
        stage: [
          {
            name: 'Selecione',
            id: ''
          },
          {
            name: 'Trial',
            id: 1
          },
          {
            name: 'Onboarding',
            id: 2
          },
          {
            name: 'Middle',
            id: 3
          },
          {
            name: 'Ongoing',
            id: 4
          },
        ],
        statusAnswered: [
          {
            name: 'Todos',
            id: 0
          },
          {
            name: 'Respondido',
            id: 1
          },
          {
            name: 'Gerado',
            id: 2
          },
        ],
        responsible: ['Selecione'],
      },
      listFilters: {
        companyId: '',
        companyName: '',
        noteExp: '',
        noteScore: '',
        stage: '',
        responsible: '',
        statusAnswered: '',
      },
      listContent: {
        header: [
          'Empresa',
          'Nota exp.',
          'Nota atendimento',
          'Comentário',
          'Etapa',
          'Reponsável',
          'Data resposta',
          'Ações'
        ],
        body: [],
      },
      rangeDays: '',
      loadingExcel: false,
    }
  },
  methods: {
    createExcel() {
      this.loadingExcel = true

      let url = GET_LIST_CSAT;
      url += '?dateInit=' + this.$route.params.csatInit + '&dateEnd=' + this.$route.params.csatEnd;


      url += '&quant=' + '9999';
      url += '&isExcelFile=' + 'true';

      if (this.listFilters.companyId) {
        url += '&companyId=' + this.listFilters.companyId
      }
      if (this.listFilters.companyName) {
        url += '&companyName=' + this.listFilters.companyName
      }
      if (this.listFilters.stage) {
        url += '&journey=' + this.listFilters.stage
      }
      if (this.listFilters.noteExp) {
        url += '&experienceScore=' + this.listFilters.noteExp
      }
      if (this.listFilters.noteScore) {
        url += '&attendingScore=' + this.listFilters.noteScore
      }
      if (this.listFilters.statusAnswered) {
        url += '&statusAnswered=' + this.listFilters.statusAnswered
      }
      if (this.listFilters.responsible !== 'Selecione' && this.listFilters.responsible !== "") {
        url += '&userResponsible=' + this.listFilters.responsible
      }

      REQUEST_SERVICE.get(url).then((response) => {

        let binaryData = [];
        binaryData.push(response.data);
        let urlResponse = window.URL.createObjectURL(new Blob(binaryData, {type: "text/csv"}))
        const a = document.createElement('a');
        a.href = urlResponse;
        a.download = 'Relatório-CSAT.csv';
        a.click();

        this.loadingExcel = false
      }).catch((reason) => {
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
        this.loadingExcel = false
      });

    },
    getList(value) {
      this.loadingList = true;

      let url = GET_LIST_CSAT;

      if (value) {
        let today = new Date();
        let init = new Date(today.getFullYear(), today.getMonth(), 1);
        let end = today.toISOString().substring(0, 10);

        url += '?dateInit=' + init.toISOString().substring(0, 10) + '&dateEnd=' + end;
      } else {
        url += '?dateInit=' + this.$route.params.csatInit + '&dateEnd=' + this.$route.params.csatEnd;
      }

      url += '&quant=' + '9999';

      if (this.listFilters.companyId) {
        url += '&companyId=' + this.listFilters.companyId
      }
      if (this.listFilters.companyName) {
        url += '&companyName=' + this.listFilters.companyName
      }
      if (this.listFilters.stage) {
        url += '&journey=' + this.listFilters.stage
      }
      if (this.listFilters.noteExp) {
        url += '&experienceScore=' + this.listFilters.noteExp
      }
      if (this.listFilters.noteScore) {
        url += '&attendingScore=' + this.listFilters.noteScore
      }
      if (this.listFilters.statusAnswered) {
        url += '&statusAnswered=' + this.listFilters.statusAnswered
      }
      if (this.listFilters.responsible !== 'Selecione' && this.listFilters.responsible !== "") {
        url += '&userResponsible=' + this.listFilters.responsible
      }

      REQUEST_SERVICE.get(url).then((response) => {
        UTIL_SERVICE.console("RESULT GET_LIST_CSAT:", response.data);

        this.dataCode = response.data
        this.listContent.body = response.data.items

        this.loadingList = false;
      }).catch((reason) => {
        this.loadingList = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    getResponsibles() {
      this.loading = true;

      REQUEST_SERVICE.get(GET_SELECT_RESPONSIBLES).then((response) => {
        UTIL_SERVICE.console("RESULT GET_SELECT_RESPONSIBLES:", response.data);

        this.listFiltersOptions.responsible.push(...response.data)
        this.loading = false;
      }).catch((reason) => {
        this.loading = false;
        ALERT_SERVICE.showMsgError(reason.response.data.erros);
      });
    },
    removeCSAT(id, context) {
      swal({
        title: "Aviso",
        text: "Deseja remover esta resposta? \n Essa ação não pode ser desfeita.",
        icon: "warning",
        buttons: {
          cancel: "Não",
          catch: {
            text: "Sim",
            value: "yes",
          }
        }
      }).then(value => {
        if (value === 'yes') {
          REQUEST_SERVICE.requestContext('DELETE', DELETE_CSAT + id, context).then((response) => {
            UTIL_SERVICE.console("RESULT DELETE_CSAT:", response.data);
            swal("Aviso", "CSAT removido!.", "success");
            this.getList();
          }).catch((reason) => {
            ALERT_SERVICE.showMsgError(reason.response.data.erros);
          });
        }
      });
    },
    // createExcel() {
    //   let bodyValue = [];
    //   this.listContent.body.map((value, index) => {
    //
    //     let journey = '';
    //     let experience = '';
    //     let attending = '';
    //
    //     if (value.journey === 1) {
    //       journey = 'Trial'
    //     }
    //     if (value.journey === 2) {
    //       journey = 'Onboarding'
    //     }
    //     if (value.journey === 3) {
    //       journey = 'Middle'
    //     }
    //     if (value.journey === 4) {
    //       journey = 'Ongoing'
    //     }
    //
    //     if (value.experienceScore === 1) {
    //       experience = '1 Muito ruim'
    //     }
    //     if (value.experienceScore === 2) {
    //       experience = '2 Ruim'
    //     }
    //     if (value.experienceScore === 3) {
    //       experience = '3 Médio'
    //     }
    //     if (value.experienceScore === 4) {
    //       experience = '4 Bom'
    //     }
    //     if (value.experienceScore === 5) {
    //       experience = '5 Muito bom'
    //     }
    //
    //     if (value.attendingScore === 1) {
    //       attending = '1 Muito ruim'
    //     }
    //     if (value.attendingScore === 2) {
    //       attending = '2 Ruim'
    //     }
    //     if (value.attendingScore === 3) {
    //       attending = '3 Médio'
    //     }
    //     if (value.attendingScore === 4) {
    //       attending = '4 Bom'
    //     }
    //     if (value.attendingScore === 5) {
    //       attending = '5 Muito bom'
    //     }
    //
    //     bodyValue.push([value.companyName, experience, attending, value.comment, journey, value.userResponsible, moment(value.responseDate).format('DD/MM/YYYY')]);
    //
    //     if (index + 1 === this.listContent.body.length) {
    //       let headValue = ["EMPRESA", "NOTA EXP", "NOTA ATENDIMENTO", "COMENTÁRIO", "ETAPA", "RESPONSAVEL", "DATA RESPOSTA"];
    //
    //       window.downloadListExcel(headValue, bodyValue, "Relatório CSAT");
    //     }
    //   });
    // },
    setRangeDays() {
      const date = new Date();
      this.rangeDays = date.getDate() - 1;
    },
  },
  beforeMount() {
    this.getResponsibles();
    this.getList(true);
    this.setRangeDays()
  },
  watch: {
    dataCode() {
      if (this.dataCode.experienceActualByPeriod > 0) this.bgExperienceBar = '#FF445D';
      if (this.dataCode.experienceActualByPeriod > 20) this.bgExperienceBar = '#FF445D';
      if (this.dataCode.experienceActualByPeriod > 40) this.bgExperienceBar = '#ff9900';
      if (this.dataCode.experienceActualByPeriod >= 80) this.bgExperienceBar = '#2ACC6B';
      if (this.dataCode.responseActualByPeriod > 0) this.bgResponseBar = '#FF445D';
      if (this.dataCode.responseActualByPeriod > 15) this.bgResponseBar = '#ff9900';
      if (this.dataCode.responseActualByPeriod >= 30) this.bgResponseBar = '#2ACC6B';
    }
  }
}
</script>

<style lang="scss" scoped>

.status {
  text-align: center;
  margin-top: 10px;

  &__emote {
    font-weight: 700;
    font-size: 18px;
    display: block;
    margin: 30px 0 20px 0;

    img {
      padding: 6px;
      border-radius: 4px !important;
    }
  }

  &__total {
    font-weight: 700;
    font-size: 26px;
    color: #191919;
  }
}

.csat-goal {
  display: flex;

  h2 {
    display: block;
    font-weight: 700;
    font-size: 14px;
    color: #191919;
    margin: 12px 0;
  }

  span {
    font-weight: 600;
  }

  .progress {
    height: 24px;
    position: relative;
    border-radius: 12px !important;
    margin-bottom: 0;
    cursor: pointer;

    .progress-bar {
      position: relative;
      font-weight: 600;
      text-align: right;
      padding: 3px 6px 0 0;
      box-shadow: none;
      border-radius: 12px !important;
    }

    .bg-progress {
      background: none;
      border-right: 1px solid #d6d6d6;
      color: #000;
      position: absolute;
      top: 0;
      opacity: 0.5;
    }

    .complete-goal {
      background: none;
      position: absolute;
      top: 0;
      z-index: 2;

      ion-icon {
        font-size: 18px;
        color: #fff;
        margin-right: 18px;
      }
    }
  }

  .tooltip-csat {
    position: absolute;
    bottom: 32px;
    left: 50%;
    transform: translateX(-50%);
    background: #fff;
    padding: 4px 12px;
    border-radius: 10px !important;
    box-shadow: 0 0 3px rgba(0, 0, 0, .2);
    visibility: hidden;
    opacity: 0;
    transition: all .2s;

    p {
      display: flex;
      gap: 4px;
      margin: 2px 0;
      font-size: 12px;

      span {
        margin: 0;
        font-size: 12px;
      }
    }
  }

  .progress:hover + .tooltip-csat {
    visibility: visible;
    opacity: 1;
  }
}

.status-csat-goal {
  font-size: 14px;
  margin: 20px 0 0 15px;

  span {
    font-weight: 600;
  }
}

.csat {
  td {
    padding-top: 15px !important;
    padding-bottom: 15px !important;
    font-weight: 400;
    font-size: 16px;
    color: #3A424E;
    vertical-align: inherit !important;

    a {
      font-weight: 400;
      font-size: 14px;
      color: #2F23D6;
      text-decoration: none;
      border-bottom: 1px solid transparent;
      transition: .2s;

      &:hover {
        border-color: #2F23D6;
      }
    }
  }

  &__remove {
    span {
      display: flex;
      align-content: center;
      color: #FF445D;
      font-size: 14px;
      font-weight: 400;
      transition: .2s;
      padding-bottom: 2px;
      border-bottom: 1px solid transparent;
      cursor: pointer;
      width: max-content;

      &:hover {
        border-color: #FF445D;
      }

      ion-icon {
        font-size: 20px;
        margin-right: 2px;
      }
    }
  }

  &__status {

  }

  &__status > &__note {
    display: flex;
    flex-direction: row;
    align-content: center;
    width: max-content;
    font-size: 14px;
    font-weight: 400;
    color: #3A424E;

    img {
      width: 20px;
      margin-right: 4px;
    }

    span {
      margin-left: 4px;
      color: #7F8897;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/restricted/customerSuccess/ReportCSAT.vue